var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    [
      _c("validation-observer", {
        ref: "validator",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var valid = ref.valid
              return [
                _c(
                  "b-form",
                  {
                    class: [_vm.inline ? "gap-2 items-center" : ""],
                    attrs: { inline: _vm.inline },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.addDestination($event)
                      },
                      reset: [
                        function($event) {
                          $event.preventDefault()
                          return _vm.clearForm($event)
                        },
                        _vm.onReset
                      ]
                    }
                  },
                  [
                    _c("validation-provider", {
                      staticClass: "flex-grow",
                      attrs: {
                        name: _vm.$t("document_destination_name"),
                        rules: "required",
                        slim: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(validationContext) {
                              return [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: _vm.$t(
                                        "document_destination_name"
                                      ),
                                      "label-for": "document_destination_name"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "required",
                                      attrs: {
                                        id: "document_destination_name",
                                        placeholder: _vm.$t(
                                          "document_destination_name"
                                        )
                                      },
                                      model: {
                                        value: _vm.destination.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.destination, "name", $$v)
                                        },
                                        expression: "destination.name"
                                      }
                                    }),
                                    _c(
                                      "b-form-invalid-feedback",
                                      { class: [{ absolute: _vm.inline }] },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              validationContext.errors[0]
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c("validation-provider", {
                      staticClass: "flex-grow",
                      attrs: {
                        name: _vm.$t("document_destination_email"),
                        rules: "required|email",
                        slim: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(validationContext) {
                              return [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-1",
                                      label: _vm.$t(
                                        "document_destination_email"
                                      ),
                                      "label-for": "document_destination_email"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "required",
                                      attrs: {
                                        id: "document_destination_email",
                                        type: "email",
                                        placeholder: _vm.$t(
                                          "document_destination_email"
                                        )
                                      },
                                      model: {
                                        value: _vm.destination.email,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.destination,
                                            "email",
                                            $$v
                                          )
                                        },
                                        expression: "destination.email"
                                      }
                                    }),
                                    _c(
                                      "b-form-invalid-feedback",
                                      { class: [{ absolute: _vm.inline }] },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              validationContext.errors[0]
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c(
                      "div",
                      { staticClass: "flex flex-row justify-end gap-4" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "documents.edit",
                                expression: "`documents.edit`"
                              },
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { "400": true }
                              }
                            ],
                            staticClass: "px-1",
                            attrs: {
                              variant: "outline-primary",
                              disabled: !valid
                            },
                            on: { click: _vm.addDestination }
                          },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: { icon: "PlusIcon" }
                            }),
                            _c("span", { staticClass: "align-middle" }, [
                              _vm._v(_vm._s(_vm.$t("add")))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(255, 255, 255, 0.15)",
                                expression: "'rgba(255, 255, 255, 0.15)'",
                                modifiers: { "400": true }
                              }
                            ],
                            staticClass: "px-1",
                            attrs: { variant: "outline-primary" },
                            on: {
                              click: function($event) {
                                return _vm.$bvModal.show("search-contact")
                              }
                            }
                          },
                          [
                            _c("b-icon-search", { staticClass: "mr-50" }),
                            _c("span", { staticClass: "align-middle" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("document_destination_search_contact")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "div",
        { staticClass: "vs-row w-full pt-2" },
        [
          _vm.service
            ? _c("grid", {
                ref: "grid-destination",
                attrs: {
                  hide_actions: false,
                  service: _vm.service,
                  route_grid_path: "/" + _vm.id + "/destinations/grid",
                  route_name: "documents",
                  column_formats: {
                    created_at: function(val) {
                      return _vm.$utils.format.date(val)
                    },
                    dispatched_at: function(val) {
                      return _vm.$utils.format.date(val)
                    },
                    status: function(val) {
                      return "" + val.label
                    }
                  },
                  css_formats: {
                    status: function(val) {
                      return "text-" + val.color
                    }
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "actions",
                      fn: function(actions) {
                        return [
                          _vm.canDispatchDestination(actions.row)
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "documents.edit",
                                    expression: "`documents.edit`"
                                  },
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Enviar ao destinatário",
                                    expression: "'Enviar ao destinatário'"
                                  }
                                ],
                                staticClass:
                                  "h-5 w-5 mb-1 mr-1 stroke-current text-primary",
                                attrs: { icon: "SendIcon" },
                                on: {
                                  click: function($event) {
                                    return _vm.dispatchDestination(
                                      actions.row.id
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm.canDeleteDestination(actions.row)
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "permission",
                                    rawName: "v-permission",
                                    value: "documents.edit",
                                    expression: "`documents.edit`"
                                  },
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Remover destinatário",
                                    expression: "'Remover destinatário'"
                                  }
                                ],
                                staticClass:
                                  "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                                attrs: { icon: "Trash2Icon" },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteDestination(actions.row.id)
                                  }
                                }
                              })
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1589798992
                )
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "flex flex-row justify-end gap-4" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: "documents.edit",
                      expression: "`documents.edit`"
                    }
                  ],
                  attrs: { variant: "warning" },
                  on: { click: _vm.dispatch }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "SendIcon" }
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("action.send_pending")) + " ")
                ],
                1
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.goBack }
                },
                [_vm._v("Voltar")]
              )
            ],
            1
          ),
          _c("calendar-contact-popup", { on: { selected: _vm.addContactList } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }